import { useState, useRef, useCallback, useEffect } from 'react';
import { noop } from '@adsk/alloy-react-helpers';
function useVisibility(_ref) {
  let {
    show: controlledShow,
    onHide: onHideProp = noop,
    onShow: onShowProp = noop,
    delayShow,
    delayHide
  } = _ref;
  const [isControlled, setIsControlled] = useState(controlledShow !== undefined);
  const [show, setShow] = useState(controlledShow || false);
  const timeoutShowRef = useRef(null);
  const timeoutHideRef = useRef(null);
  const clearShowAndHideTimeouts = useCallback(() => {
    var _timeoutShowRef$curre, _timeoutHideRef$curre;
    clearTimeout((_timeoutShowRef$curre = timeoutShowRef.current) !== null && _timeoutShowRef$curre !== void 0 ? _timeoutShowRef$curre : undefined);
    clearTimeout((_timeoutHideRef$curre = timeoutHideRef.current) !== null && _timeoutHideRef$curre !== void 0 ? _timeoutHideRef$curre : undefined);
  }, []);

  // this is required by OverflowTooltip as it can change from controlled to
  // uncontrolled and vice versa
  useEffect(() => {
    setIsControlled(controlledShow !== undefined);
  }, [controlledShow]);
  useEffect(() => {
    // Clear timeouts when unmounting
    return clearShowAndHideTimeouts;
  }, [clearShowAndHideTimeouts]);
  const onShow = useCallback(() => {
    clearShowAndHideTimeouts();
    timeoutShowRef.current = setTimeout(() => {
      onShowProp();
      if (!isControlled) {
        setShow(true);
      }
    }, delayShow);
  }, [clearShowAndHideTimeouts, delayShow, isControlled, onShowProp]);
  const onHide = useCallback(() => {
    clearShowAndHideTimeouts();
    timeoutHideRef.current = setTimeout(() => {
      onHideProp();
      if (!isControlled) {
        setShow(false);
      }
    }, delayHide);
  }, [clearShowAndHideTimeouts, delayHide, isControlled, onHideProp]);
  const handleToggle = useCallback(() => {
    const showValue = isControlled ? controlledShow : show;
    showValue ? onHide() : onShow();
  }, [isControlled, controlledShow, show, onHide, onShow]);
  return {
    show: isControlled ? !!controlledShow : show,
    onHide,
    onShow,
    /** @deprecated use onShow because functionality has been combined and made the same */
    handleShow: onShow,
    /** @deprecated use onHide because functionality has been combined and made the same */
    handleHide: onHide,
    handleToggle
  };
}
export default useVisibility;
//# sourceMappingURL=useVisibility.js.map